import React from 'react';

function Experience({ title, date, description }) {
  return (
     
      <div className='flex flex-col mt-6 sm:mt-10 items-start sm:items-center justify-center'>
        <div className='flex flex-col sm:flex-row gap-4 sm:gap-10 ml-2 sm:ml-4 w-full'>
          <div className='text-sm sm:text-base mb-2 ml-[-3px] min-w-[10vw] sm:min-w-[120px] mt-[0.1rem]'>
            <h3 className='text-xs sm:text-sm text-left sm:text-center my-1 font-medium text-gray-600 dark:text-gray-400'>{date}</h3>
          </div>
          <div className='flex relative mt-[5px] flex-col sm:ml-[-29px]'>
            <div className='w-3 h-3 sm:w-4 sm:h-4 bg-[#ec6e59] rounded-full border-2 border-white dark:border-[#20262E]'></div>
            <div className='absolute top-[18px] sm:top-[22px] bottom-[-26px] left-[5px] sm:left-[7px] border-dotted border-l-2 border-gray-300 dark:border-gray-600'></div>
          </div>
          <div className='flex flex-col mt-0 sm:mt-1 w-full sm:min-w-[50vw] sm:max-w-[70vw] lg:max-w-[50rem]'>
            <h1 className='text-base sm:text-lg md:text-xl mb-1.5 sm:mb-2 w-fit font-semibold text-gray-900 dark:text-white'>{title}</h1>
            <p className='font-light w-full sm:w-[90%] md:w-[80%] text-sm sm:text-base leading-relaxed text-justify text-gray-700 dark:text-gray-300'>
              {description}
            </p>
          </div>
        </div>
      </div>
   
  );
}

export default Experience;

 